if (!customElements.get('supplement-facts')) {
  customElements.define(
    'supplement-facts',
    class SupplementFacts extends HTMLElement {
      connectedCallback() {
        this.panels = this.querySelectorAll('[data-supplement-facts-panel]');

        if (!this.panels.length) return;

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this),
        );
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
      }

      handleOptionValueChange({ data: { selectedOptionValues } }) {
        const selectedKey = JSON.stringify(selectedOptionValues);
        let hasMatch = false;

        this.panels.forEach((panel) => {
          const isMatch = panel.dataset.variantOptions === selectedKey;

          panel.classList.toggle('hidden', !isMatch);
          if (isMatch) hasMatch = true;
        });

        this.classList.toggle('hidden', !hasMatch);
      }
    },
  );
}
